import styled from 'styled-components';
import { colors } from '../../assets/colors/colors';

export const Text = styled.p`
  color: ${colors.white};
  margin: 15px;
  font-weight: bold;
  letter-spacing: 1px;
`;
